export default "__VITE_ASSET__COJOLjwy__"